module.exports = __webpack_public_path__ + "static/media/drip.png.png.2fb4d700.webp";